/* eslint-disable react/display-name */
import { forwardRef, useState } from 'react'
import type { InputProps } from './Input'
import { Input } from './Input'
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/20/solid'
import { i18n } from '@lingui/core'
import { classNames } from '~/utils/client/helpers'

export const PasswordInput = forwardRef<HTMLInputElement, InputProps>(
  ({ type = 'password', ...inputProps }: InputProps, ref) => {
    const [isVisible, setIsVisible] = useState(false)

    const ObscureIcon = isVisible ? EyeSlashIcon : EyeIcon
    const hasOwnHelper = Boolean(inputProps.helper)
    const hasNeighbourHelper = inputProps.neighbourHasHelper
    // see @Input Component
    const inputId = inputProps.id ?? inputProps.name

    const handleObscureToggle = () => {
      setIsVisible((prevState) => !prevState)
    }

    return (
      <div className="relative flex">
        <Input type={isVisible ? 'text' : 'password'} {...inputProps} ref={ref} />
        <button
          type="button"
          aria-label={isVisible ? i18n._('Passwort verbergen') : i18n._('Passwort anzeigen')}
          aria-pressed={isVisible}
          aria-controls={inputId}
          className={classNames(
            'absolute right-5 top-4 flex h-6 w-6 cursor-pointer items-center justify-center focus-ring-brand',
            hasOwnHelper && 'top-11',
            !hasOwnHelper && hasNeighbourHelper && 'sm:top-11'
          )}
          onClick={handleObscureToggle}
        >
          <ObscureIcon className="h-4 w-4" aria-hidden="true" />
        </button>
      </div>
    )
  }
)
